import { FC } from "react";
import KickImage from 'Reuseables/KickImage';

import CustomBody from "../../CustomBody/index";
import PickupAddress from "../../../../../images/pickup-address.png";

//Definitions
import { NoAddressProps } from "./definitions";

const NoAddress: FC<NoAddressProps> = ({
  onBack,
  addAddress
}) => {
  return (
    <CustomBody withBack backAction={onBack}>
      <div className="pickup-address-body no-address">
        <KickImage className="pickup-address-img" src={PickupAddress} alt="pickup address" />
        <p className="title">No address yet</p>
        <p className="info">Please add address detail to help <span /> courier find your locations</p>
        <p className="add-new-address" onClick={addAddress}>Add new address</p>
      </div>
    </CustomBody>
  )
}
NoAddress.defaultProps = {
  onBack: () => { },
  addAddress: () => { }
}

export default NoAddress;